// extracted by mini-css-extract-plugin
export default {"appRecommend":"index_appRecommend_ZlTCA"};